import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Mountain, CloudRain } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="py-20 md:py-32 bg-brand-cream overflow-hidden" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-11">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-12">
            <div className="absolute -top-4 -left-4 w-full h-full border-4 border-brand-red rounded-sm z-0 hidden md:block" data-id="element-13" />
            <img src="https://images.unsplash.com/photo-1504630083234-14187a9df0f5?w=800&q=80" alt="Coffee farm in the mountains" className="relative z-10 w-full h-[500px] object-cover rounded-sm shadow-xl grayscale hover:grayscale-0 transition-all duration-700" data-id="element-14" />

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-brand-black text-white p-6 z-20 shadow-lg max-w-xs hidden md:block" data-id="element-15">
              <p className="font-display font-bold text-2xl text-brand-red" data-id="element-16">
                1,950m
              </p>
              <p className="text-sm uppercase tracking-wider" data-id="element-17">
                Elevation Above Sea Level
              </p>
            </div>
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-18">
            <div className="flex items-center mb-6" data-id="element-19">
              <span className="h-1 w-12 bg-brand-red mr-4" data-id="element-20"></span>
              <span className="text-brand-red font-display font-bold uppercase tracking-widest" data-id="element-21">
                Our Story
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-display font-bold text-brand-black mb-8 leading-tight" data-id="element-22">
              Rooted in the Highlands of{' '}
              <span className="text-brand-red" data-id="element-23">Mt. Elgon</span>
            </h2>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-24">
              Blazing Barry's Coffee is a youth-led Kenyan specialty coffee
              brand rooted in the fertile highlands of Trans Nzoia, at the
              foothills of Mt. Elgon. Grown at elevations of 1,950 meters above
              sea level, our coffee benefits from rich volcanic soils, cool
              mountain climates, and abundant natural rainfall—ideal conditions
              for exceptional Kenyan Arabica.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-10" data-id="element-25">
              <div className="flex flex-col items-center text-center p-4 bg-white shadow-sm rounded-sm border-b-2 border-brand-red" data-id="element-26">
                <Mountain className="text-brand-red mb-3 h-8 w-8" data-id="element-27" />
                <h3 className="font-display font-bold text-brand-black" data-id="element-28">
                  Mt. Elgon
                </h3>
                <p className="text-xs text-gray-500 mt-1" data-id="element-29">Volcanic Soils</p>
              </div>
              <div className="flex flex-col items-center text-center p-4 bg-white shadow-sm rounded-sm border-b-2 border-brand-red" data-id="element-30">
                <MapPin className="text-brand-red mb-3 h-8 w-8" data-id="element-31" />
                <h3 className="font-display font-bold text-brand-black" data-id="element-32">
                  Trans Nzoia
                </h3>
                <p className="text-xs text-gray-500 mt-1" data-id="element-33">Origin</p>
              </div>
              <div className="flex flex-col items-center text-center p-4 bg-white shadow-sm rounded-sm border-b-2 border-brand-red" data-id="element-34">
                <CloudRain className="text-brand-red mb-3 h-8 w-8" data-id="element-35" />
                <h3 className="font-display font-bold text-brand-black" data-id="element-36">
                  High Rainfall
                </h3>
                <p className="text-xs text-gray-500 mt-1" data-id="element-37">Ideal Climate</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}